<template>
  <div class="actionPlan actionPlan_add_css">
    <div class="add">
      <GradeDetail :id="gradeId" :getDatas="getGradeData"></GradeDetail>
      <div class="addBox">
        <div class="title">
          添加阶段学习任务
        </div>
        <ul class="top">
          <li>
            <span>学期</span>
            <el-input :value="gradeData.gradeName" disabled></el-input>
          </li>
          <li>
            <span>考试</span>
            <el-input :value="gradeData.nameName" disabled></el-input>
          </li>
        </ul>
        <table>
          <tbody>
          <tr>
            <th style="width:260px">科目</th>
            <th v-for="(item,index) in subject" :key="index">
              {{item.subject}}
            </th>
          </tr>
          <tr>
            <td>学期目标分数</td>
            <td v-for="(item,index) in subject" :key="index">
              {{item.semesterTargetScore}}
            </td>
          </tr>
          <tr>
            <td>学期名次目标</td>
            <td v-for="(item,index) in subject" :key="index">
              {{item. semesterRankingGoals}}
            </td>
          </tr>
          <tr>
            <td>阶段分数目标</td>
            <template v-for="(item,index) in subject" >
              <template v-if="jieduanBool">
                <td :key="index">
                  <el-input v-model="item.stageScoreGoal"></el-input>
                </td>
              </template>
              <template v-else>
                <td style="color:#ababab" :key="index">
                  {{item.stageScoreGoal}}
                </td>
              </template>
            </template>
          </tr>
          <tr>
            <td>阶段名次目标</td>
            <template v-for="(item,index) in subject" >
              <template v-if="jieduanBool">
                <td  :key="index">
                  <el-input v-model="item.stageRankingGoal"></el-input>
                </td>
              </template>
              <template v-else>
                <td style="color:#ababab" :key="index">
                  {{item.stageRankingGoal}}
                </td>
              </template>
            </template>
          </tr>
          </tbody>
        </table>
        <ul class="top" style="margin-top: 30px">
          <li>
            <span>行动计划</span>
            <el-select  style="width:162px;" v-model="actionPlan" placeholder="请选择"  v-if="arrayPlan">
              <el-option
                  v-for="(item,key) in actionPlanData"
                  :key="key"
                  :label="item.name"
                  :disabled="arrayPlan.indexOf(key+1)>=0"
                  :value="item.value">
              </el-option>
            </el-select>
          </li>
        </ul>
        <table class="table2" style="margin-top: 20px">
          <tbody>
            <tr>
              <th>学科</th>
              <th>阶段问题</th>
              <th>阶段任务</th>
            </tr>
            <template v-for="(item,key) in  subjectStress||[]">
              <template v-for="(it,i) in  item.task||[]">
                <tr v-if="i==0" >
                  <td :rowspan="item.task.length">
                    <img src="~@img/xueyezixun/public/star.png" alt="" style="position: relative;
                        top:5px;left:-6px;margin-left:-10px">{{item.subject}}
                  </td>
                  <td >
                    <input v-model="it.stageProblem"></input>
                  </td>
                  <td>
                    <input v-model="it.stageTask"></input>
                    <span class="jiahao" :style="{display:i==item.task.length-1?'':'none'}" @click="addItem(item)">
                      <img src="~@img/xueyezixun/public/add.png" alt="">
                    </span>
                  </td>
                </tr>
                <tr  v-else-if="i == (item.task.length - 1)" >
                  <td style="background: none">
                    <input v-model="it.stageProblem"></input>
                  </td>
                  <td>
                    <input v-model="it.stageTask"></input>
                    <span class="jiahao" :style="{display:i==item.task.length-1?'':'none'}" @click="addItem(item)">
                      <img src="~@img/xueyezixun/public/add.png" alt="">
                    </span>
                  </td>
                </tr>
                <tr v-else >
                  <td style="background: none">
                    <input v-model="it.stageProblem"></input>
                  </td>
                  <td>
                    <input v-model="it.stageTask"></input>
                  </td>
                </tr>
              </template>
            </template>
            <template v-for="(item,key) in  subjectCommon||[]">
              <template v-for="(it,i) in  item.task||[]">
                <tr v-if="i==0" >
                  <td :rowspan="item.task.length">
                    {{item.subject}}
                  </td>
                  <td>
                    <input v-model="subjectCommon[key]['task'][i]['stageProblem']" ></input>
                  </td>
                  <td>
                    <input v-model="it.stageTask"></input>
                    <span class="jiahao" :style="{display:i==item.task.length-1?'':'none'}" @click="addItem(item)">
                      <img src="~@img/xueyezixun/public/add.png" alt="">
                    </span>
                  </td>
                </tr>
                <tr  v-else-if="i == (item.task.length - 1)" >
                  <td style="background: none">
                    <input v-model="it.stageProblem"></input>
                  </td>
                  <td>
                    <input v-model="it.stageTask"></input>
                    <span class="jiahao" :style="{display:i==item.task.length-1?'':'none'}" @click="addItem(item)">
                      <img src="~@img/xueyezixun/public/add.png" alt="">
                    </span>
                  </td>
                </tr>
                <tr v-else >
                  <td style="background: none">
                    <input v-model="it.stageProblem"></input>
                  </td>
                  <td>
                    <input v-model="it.stageTask"></input>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
        <div class="title">
          学习习惯养成
          <span class="addjahao" @click="addLearnHabit(1)">
            <img src="~@img/xueyezixun/public/add.png" alt="" style="vertical-align: bottom;cursor: pointer">
          </span>
        </div>
        <div>
          <table v-for="(item,index) in subjectLearnHabit||[]"  :key="index" style="margin-bottom: 30px">
            <tbody>
            <tr>
              <th colspan="2"></th>
            </tr>
            <tr>
              <td>阶段问题</td>
              <td>
                <input type="text" v-model="item.stageProblem" :disabled="item.disabled"  style="background: none">
              </td>
            </tr>
            <tr>
              <td>目标习惯</td>
              <td>
                <input type="text" v-model="item.targetHabit" :disabled="item.disabled" style="background: none">
              </td>
            </tr>
            <tr>
              <td>行动方案</td>
              <td>
                <input type="text" v-model="item.actionPlan" :disabled="item.disabled" style="background: none">
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="title">
          路径条件
          <span>
             <img src="~@img/xueyezixun/public/add.png" alt="" style="vertical-align: bottom;cursor: pointer" @click="addLearnHabit(2)">
          </span>
        </div>
        <div>
          <table v-for="(item,index) in subjectPathCondition||[]"  :key="index" style="margin-bottom: 30px">
            <tbody>
            <tr>
              <th colspan="2"></th>
            </tr>
            <tr>
              <td>阶段目标</td>
              <td>
                <input type="text" v-model="item.stageTarget">
              </td>
            </tr>
            <tr>
              <td>阶段任务</td>
              <td>
                <input type="text" v-model="item.stageTask" >
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div>
          <SummaryTitle title="咨询记录"></SummaryTitle>
          <el-input type="textarea" v-model="consultRecord"></el-input>
        </div>
      </div>
    </div>
    <div class="bottom" style="width: 300px;margin: 40px auto;display: flex;justify-content: space-between">
      <Button name="预览"
              @handleClick="preview" :style="{borderRadius:'16px'}"></Button>
      <Button name="发布计划"  @handleClick="submit" :style="{borderRadius:'16px'}"></Button>
    </div>
    <Popup v-if="popup_bool" :inter-view="interView" :get-child-data="true" :getPopupBool="getPopupBool" :getPopupData="getPopupData" ></Popup>
  </div>
</template>
<script>
import MessageTitle from '@/components/xueyezixun/MessageTitle.vue'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
import GradeDetail from './gradeDetail';
import Popup from '@/components/xueyezixun/InterviewPopup'
export default {
  name: 'gradeDetail',
  components:{MessageTitle ,CircleName,SummaryTitle,Button,GradeDetail,Popup  },
  data() {
    if(window.sessionStorage.getItem('actionPreview')){
      return JSON.parse(window.sessionStorage.getItem('actionPreview'))
    }else{
      return {
        gradeId: this.$route.query.gradeDetailId,
        interView: [{
          category: 4,
          interViewTheme: '行动计划'
        }],
        studentId: window.sessionStorage.getItem('studentId'),
        // popup_bool: false,
        popup_bool:true,
        getChildData: true,
        gradeData: {},
        subject: [],
        subjectStress: [],
        subjectCommon: [],
        condition:'',
        subjectLearnHabit: [
          {
            stageProblem: "",
            targetHabit: "",
            actionPlan: "",
            completeEffect:'',
            taskComplete:""
          }
        ],
        subjectPathCondition: [
          {
            stageTarget: "",
            stageTask: ""
          },
        ],
        consultRecord: '',
        actionPlan: '',
        actionPlanData:[
          {value:1,name:'第一次'},
          {value:2,name:'第二次'},
          {value:3,name:'第三次'},
          {value:4,name:'第四次'},
        ],
        grades:["高一上学期","高一下学期","高二上学期","高二下学期","高三上学期","高三下学期"],
        tests:["第一次月考","第二次月考","第三次月考","第四次月考"],
        gradeName:'',
        testName:'',
        arrayPlan:this.$route.query.array,
        jieduanBool:true,
        interViewData:{}
      }
    }

  },
  methods: {
    getPopupBool(bool) {
      this.popup_bool= bool
    },
    getPopupData(obj){
      this.interViewData=obj
    },
    getGradeData(obj){
      if(sessionStorage.getItem('actionPreview')){
        return;
      }
      let  { jieduanBool }=this
      let {subject,gradeName,nameName,actionSubject} = obj
      let subjectData = [];
      if(actionSubject.length>0){
        subjectData = actionSubject
        jieduanBool = false
      }else{
        subject.forEach(item=>{
          subjectData.push({
            subject:item.subject,
            semesterTargetScore: "",
            semesterRankingGoals: "",
            stageScoreGoal: "",
            stageRankingGoal: ""
          })
        })
        subjectData.push({
          subject:'总分/名次',
          semesterTargetScore: "",
          semesterRankingGoals: "",
          stageScoreGoal: "",
          stageRankingGoal: ""
        })
      }
        this.subject=subjectData;
        this.gradeName=gradeName;
        this.nameName=nameName;
        this.jieduanBool=jieduanBool;
        this.$nextTick(()=>{
          this.getNowTarget(gradeName)
        })
        let subjectStress = subject.filter(item => {
          item.task = [
            {
              stageProblem: '',
              stageTask: ''
            }
          ]
          return item.important == 1
        })
        let subjectCommon = subject.filter(item => {
          return item.important == 0
        })
        this.gradeData=obj;
        this.subjectStress=subjectStress;
        this.subjectCommon=subjectCommon;
    },
    getNowTarget(name){
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.getCurrentSemesterConditionalGoals, {
        name:name,
        studentId:sessionStorage.getItem('myStudentStudentId')
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          if(res.data.data.condition.length==0){
            return;
          }
          let data=JSON.parse(res.data.data.condition);
          if(data.length>0){
            let kemu=data[0]['kemu']
            let scores=data[0]['xueye'][0].value;
            let rank=data[0]['xueye'][1].value;
            const {subject}=this;
            subject.forEach(item=>{
              kemu.forEach(it=>{
                if(item.subject==it.name){
                  item.semesterRankingGoals=it.rank;
                  item.semesterTargetScore=it.score
                }
              })
              if(item.subject=='总分/名次'){
                item.semesterRankingGoals=rank;
                item.semesterTargetScore=scores;
              }
            })
            this.condition=data[0].tiaojian;
            this.subject=subject;
          }
        }else{

        }
      })
    },
    getLearningHabitsDetaiL(){
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.LearningHabitsDetail, {
        studentId:sessionStorage.getItem('myStudentStudentId')
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          if(res.data.data.length>0){
            let data =res.data.data;
            data.forEach(item=>{
              item.disabled = true
            })
            this.subjectLearnHabit=data
          }
        }else{

        }
      })
    },
    //筛选科目
    screenSubject(name){
      if (name == '语文') {
        return 1
      }
      if (name == '数学') {
        return 2
      }
      if (name == '外语'|| name == '英语') {
        return 3
      }
      if (name == '物理') {
        return 4
      }
      if (name == '化学') {
        return 5
      }
      if (name == '生物') {
        return 6
      }
      if (name == '历史') {
        return 7
      }
      if (name == '地理') {
        return 8
      }
      if (name == '政治') {
        return 9
      }
      if (name == '技术') {
        return 10
      }
      return 0
    },
    //添加行动计划条目
    addItem(item){
      item.task.push({
        stageProblem: '',
        stageTask: ''
      })
      this.$forceUpdate()
    },
    //添加学习习惯\路径条件条目
    addLearnHabit(number){
      if(number==1){
        this.subjectLearnHabit.push({
          stageProblem: "",
          targetHabit: "",
          actionPlan: "",
          completeEffect:'',
          taskComplete:""
        })
      }else{
        this.subjectPathCondition.push({
          stageTarget: "",
          stageTask: ""
        },)
      }
      this.$forceUpdate()
    },
    preview(){
      for(let i=0;i<$('.addBox input[type=text]').length;i++){
        if(!$('.addBox input[type=text]')[i].value){
          this.$message.error("请将数据补充完整")
          return;
        }
      }

      if(!this.actionPlan||(!this.consultRecord)){
        this.$message.error("请将数据补充完整")
        return;
      }
      window.sessionStorage.setItem('actionPreview',JSON.stringify(this._data))
      this.$router.push({
        path:'/consultant/minestudent/main/implement/actionplan/preview',
        query:this.$route.query
      })
    },
    submit(){
      const {studentId, gradeId, actionPlan, subject, consultRecord
        , interViewData, subjectStress, subjectCommon, subjectLearnHabit
        , subjectPathCondition ,gradeName, nameName} = this;
      let subjectStress_item=[],
          subjectCommon_item=[];
      subjectStress.forEach(item=>{
        let subject =this.screenSubject(item.subject)
        item.task.forEach(it=>{
          let object = {
            subject:subject,
            ...it
          }
          subjectStress_item.push(object)
        })
      })
      subjectCommon.forEach(item=>{
        let subject =this.screenSubject(item.subject)
        item.task.forEach(it=>{
          let object = {
            subject:subject,
            ...it
          }
          subjectCommon_item.push(object)
        })
      })
      subjectLearnHabit.forEach(item=>{
        if(item.disabled){
          delete item.disabled
        }
      })
      for(let i=0;i<$('.addBox input[type=text]').length;i++){
        if(!$('.addBox input[type=text]')[i].value){
          this.$message.error("请将数据补充完整")
          return;
        }
      }

      if(!actionPlan||(!consultRecord)){
        this.$message.error("请将数据补充完整")
        return;
      }
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.add, {
        studentId:sessionStorage.getItem('myStudentStudentId'),
        studentTestScoreId:gradeId,
        actionPlan:actionPlan,
        subject:subject,
        consultRecord:consultRecord,
        interviewRecord:interViewData,
        subjectStress:subjectStress_item,
        subjectCommon:subjectCommon_item,
        subjectLearnHabit:subjectLearnHabit,
        subjectPathCondition:subjectPathCondition,
        semester:gradeName,
        monthly_exam:nameName
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let data=res.data;
          sessionStorage.removeItem('actionPreview')
           this.$router.push( {path:'/consultant/minestudent/main/implement/actionplan/show',
             query:{gradeId:this.gradeId,actionPlanId:data.data.id}})
        }else{

        }
      })
    },
  },
  mounted() {
    if(!sessionStorage.getItem('actionPreview')){
      this.getLearningHabitsDetaiL()
    }
  }
}
</script>
<style scoped lang="less">
th{
  font-weight: bolder;
  text-align: center;
  color:#5C5C5C;
}
@import "./css/index.less";
</style>
<style lang="less">
.actionPlan_add_css{
  .el-input__inner{

    line-height: 32px;
    // border:none;
    // text-align: center;
  }
  .top{
    .el-input__inner{
      border: 1px solid #DCDFE6;
    }
  }
  .table2{
    .el-input__inner{
      border: none;
      line-height: 32px;
    }
  }

}
</style>